<div
  #positionModal
  class="modal-dialog"
  role="document"
  [style.top]="topPosition + 'px'"
  [style.left]="leftPosition + 'px'"
  [style.min-width]="modalWidth + 'px'"
>
  <div class="modal-content inner-modal-content">
    <div class="modal-header d-flex align-items-center justify-content-between mb-3">
      <h2 class="xs-title bold" id="modal-basic-title">
        {{ title }}
      </h2>
      @if (showCrossBtn) {
        <span (click)="dismiss()" class="bi bi-x med_close-icon"></span>
      }
    </div>
    <div class="modal-body" [ngClass]="{ centered: showActionBtn }">
      <p class="m-body" [innerHTML]="messageAlert | safeHtml | async"></p>
    </div>
    @if (secundaryMessageAlert) {
      <div class="modal-body" [ngClass]="{ centered: showActionBtn }">
        <p class="m-body text-danger bold">{{ secundaryMessageAlert }}</p>
      </div>
    }
    <div class="modal-footer">
      @if (showActionBtn) {
        <button type="button" class="btn btn-secondary w-100" (click)="close()">
          @if (showActionIcon) {
            <app-icon icon="{{ icon }}" class="icon-light" />
          }
          {{ actionText }}
        </button>
        <button type="button" class="btn btn-outline w-100" (click)="dismiss()">
          {{ closeText | titlecase }}
        </button>
        @if (showCancelBtn) {
          <button type="button" class="btn btn-link w-100" (click)="cancel()">
            {{ cancelText | titlecase }}
          </button>
        }
      } @else {
        <button type="button" class="btn btn-primary w-100" (click)="dismiss()">
          {{ closeText | titlecase }}
        </button>
      }
    </div>
  </div>
</div>
